module.exports = __webpack_public_path__ + "img/SSS-J-10.99524ce9.svg";